import AuditLogsOverview from "@/modules/auditLogs/views/AuditLogsView.vue";

export const AuditLogsRoutes = [
    {
        path: '/audit/logs',
        component: AuditLogsOverview,
    }
]